<template>
  <div class="common_popup_area">
    <div class="common_popup_box">
      <div class="popup_box_top">
        <h3>비밀번호가 변경되었습니다.</h3>
      </div>
      <div class="popup_box_bot">
        <p class="confirm_btn" @click="$emit('closeSetting')">확인</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'changePasswordComplete'
}
</script>
<style src="@/assets/css/content.css"></style>
